import React from 'react';
import { FadeIn } from './FadeIn';
export function Tomos() {
  const tomos = [{
    num: 1,
    title: 'Conciencia Fonológica',
    desc: 'Actividades para desarrollar la base auditiva y fonológica de la lectoescritura.',
    color: 'bg-rose-500'
  }, {
    num: 2,
    title: 'Letras y Sonidos',
    desc: 'Recursos para enseñar y consolidar la correspondencia letra-sonido.',
    color: 'bg-amber-500'
  }, {
    num: 3,
    title: 'Escritura Inicial',
    desc: 'Secuencias y prácticas para acompañar las primeras producciones escritas.',
    color: 'bg-emerald-500'
  }, {
    num: 4,
    title: 'Lectura y Comprensión',
    desc: 'Textos, preguntas y guías para entrenar comprensión y velocidad lectora.',
    color: 'bg-sky-500'
  }, {
    num: 5,
    title: 'Producción Escrita',
    desc: 'Plantillas y consignas para que los niños escriban con más claridad y autonomía.',
    color: 'bg-violet-500'
  }, {
    num: 6,
    title: 'Intervención y Seguimiento',
    desc: 'Herramientas para registrar avances, ajustar el plan y documentar el proceso.',
    color: 'bg-pink-500'
  }];
  return <section className="pt-6 pb-12 bg-black" data-id="element-333">
      <div className="max-w-4xl mx-auto px-4" data-id="element-334">
        <FadeIn className="text-center mb-10" data-id="element-335">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-mint mb-4" data-id="element-336">
            ¿QUÉ INCLUYE EL MEGAPACK?
          </h2>
          <p className="text-base md:text-lg text-white/60 max-w-2xl mx-auto" data-id="element-337">
            +360 páginas en PDF, listas para imprimir o usar desde celular,
            tablet o computadora.
          </p>
        </FadeIn>

        <div className="space-y-5" data-id="element-338">
          {tomos.map((tomo, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-339">
              <div className="flex items-start gap-4 py-3 px-4" data-id="element-340">
                <span className={`w-10 h-10 shrink-0 rounded-full ${tomo.color} flex items-center justify-center text-white font-bold text-sm shadow-lg mt-0.5`} data-id="element-341">
                  {tomo.num}
                </span>
                <div data-id="element-342">
                  <h3 className="font-bold text-lg md:text-xl text-white" data-id="element-343">
                    <span className="text-mint" data-id="element-344">Tomo {tomo.num}</span> —{' '}
                    {tomo.title}
                  </h3>
                  <p className="text-white/60 text-sm md:text-base mt-1" data-id="element-345">
                    {tomo.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* PLAN PRO recursos */}
        <FadeIn delay={0.2} className="mt-12" data-id="element-346">
          <div className="bg-surface border-2 border-mint/40 rounded-2xl p-6 md:p-8 relative" data-id="element-347">
            <div className="absolute -top-3 left-6 bg-mint text-black px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-348">
              💼 PLAN PRO
            </div>
            <h3 className="font-display text-2xl md:text-3xl font-bold text-mint mt-2 mb-2" data-id="element-349">
              Intervención y Gestión Profesional
            </h3>
            <p className="text-white/60 mb-5" data-id="element-350">
              Pasá de tener materiales sueltos a contar con un sistema completo
              de trabajo profesional. Incluye 5 recursos premium:
            </p>
            <ul className="space-y-3" data-id="element-351">
              {['Rutas de Intervención PRO', 'Informes PRO Listos para Adaptar', 'Agenda PRO del Consultorio', 'Mapa PRO de Decisión Psicopedagógica', 'Kit PRO de Devoluciones Profesionales'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white/85" data-id="element-352">
                  <span className="w-7 h-7 shrink-0 rounded-full bg-mint/20 text-mint flex items-center justify-center text-xs font-bold" data-id="element-353">
                    {i + 1}
                  </span>
                  <span className="font-medium" data-id="element-354">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}